export function debounce<Fn extends (...args: any[]) => void>(fn: Fn, wait: number) {
    let timer: ReturnType<typeof setTimeout>;

    return (...args: Parameters<Fn>) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), wait);
    };
}
